<div
  [ngClass]="{
    'nvc-display-none': data.showMenu,
    'ws-margin-right': !slotService.websitePromolinkCB
  }"
  fxLayout="row"
  [fxLayoutAlign]="
    slotService.websitePromolinkCB && isMobileDevice
      ? 'end center'
      : 'space-between center'
  "
  *ngIf="
    !(
      !slotService.isEmbedded &&
      slotService.is3DBoard &&
      slotService.isHeaderAndFooter &&
      !data.showMenu &&
      (!isMobileDevice || (isMobileDevice && !data.showPopup))
    ) &&
    !slotService.isSTLPromolink &&
    !data?.ARDialog
  "
>
  <div
    class="nvc-new-preview"
    *ngIf="
      data.previewImages[
        slotService.collectionsList[data.menuPreviewIndex]?._id
      ] &&
      data.showMenu &&
      data.showPreview &&
      !isMobileDevice &&
      !isTabDevice
    "
  >
    <img
      class="nvc-preview-image nvc-height-hundred"
      *ngIf="
        data.previewImages[
          slotService.collectionsList[data.menuPreviewIndex]._id
        ]
      "
      src="{{
        data.previewImages[
          slotService.collectionsList[data.menuPreviewIndex]._id
        ]
      }}"
      alt=""
    />
  </div>
  <mat-drawer
    #collectionsListDrawer
    mode="over"
    class="nvc-mat-drawer"
    fxLayout="row"
  >
    <div
      class="grid-view-main-container"
      *ngIf="data.gridView"
      [ngClass]="{
        'nvc-add-scroll': slotService.collectionsList?.length > 12,
        'center-align-grid': !(slotService.collectionsList?.length > 12)
      }"
    >
      <div id="gallery">
        <div
          fxLayout="row"
          class="ws-cursor-pointer nvc-menu-text nvc-margin-menu nvc-position-absolute nvc-menu-height"
          fxLayoutAlign="start center"
        >
          <mat-icon
            (click)="collectionsListDrawer.close(); data.showMenu = false"
            matTooltip="close"
            class="ws-cursor-pointer"
            style="padding-right: 20px"
            >close</mat-icon
          >
          <div class="nvc-menu nvc-menu-text">Menu</div>
          <img
            (click)="data.gridView = false"
            matTooltip="Grid View"
            class="nvc-video-cam ws-cursor-pointer"
            src="assets/icons/view_agenda_black.svg"
            alt=""
          />
        </div>

        <div
          (click)="onPreviewClick.emit(i)"
          *ngFor="let collection of slotService.collectionsList; let i = index"
          class="video-container-grid"
        >
          <div style="width: 100%; height: 100%" class="nvc-position-relative">
            <div class="nvc-grid-name nvc-position-absolute">
              {{ collection.name }}
            </div>
            <img
              *ngIf="data.previewImages[slotService.collectionsList[i]._id]"
              src="{{ data.previewImages[slotService.collectionsList[i]._id] }}"
              style="width: 100%; height: 100%; object-fit: contain"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="!data.gridView"
      class="nvc-new-sidebar nvc-height-hundred nvc-position-relative"
      fxLayout="column"
      (mouseleave)="closeMenuAction()"
    >
      <div
        class="nvc-position-relative nvc-side-gap nvc-width-hundred"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <img
          [src]="
            data.buyerImage
              ? imagesService.getImageURL(data.buyerImage)
              : 'assets/icons/Shopconnect_logo_new.png'
          "
          alt="Buyer Brand Image"
          class="nvc-buyer-image"
        />
        <mat-icon
          *ngIf="!isMobileDevice"
          (click)="closeMenuAction()"
          matTooltip="Close"
          class="ws-cursor-pointer nvc-close-icon"
          >close</mat-icon
        >
      </div>
      <div
        *ngIf="!data.isCartMenuOpened"
        fxLayout="row"
        fxLayoutAlign="start center"
        class="nvc-margin-menu-header nvc-side-gap"
      >
        <div fxLayout="row" FxLayoutAlign="space-evenly">
          <div
            class="nvc-collection-index nvc-menu-hover"
            fxLayout="row"
            FxLayoutAlign="center center"
            [ngClass]="
              data.collectionIndex > 9
                ? 'nvc-font-smaller nvc-padding-small'
                : 'nvc-font-16'
            "
          >
            <span>{{ data.collectionIndex }}</span>
            <span
              [ngClass]="
                slotService.collectionsList?.length > 9
                  ? 'nvc-count-denom'
                  : 'nvc-font-small'
              "
              >/{{ slotService.collectionsList.length }}</span
            >
          </div>

          <div
            class="nvc-menu-text ws-bold nvc-padding-top sc-menu sc-ordername notranslate"
            [ngClass]="isMobileDevice ? 'sc-menu-text-width-mobile' : ''"
            [matTooltip]="data.orderName"
            matTooltipClass="notranslate"
          >
            {{ data.orderName }}
          </div>
        </div>
      </div>
      <div
        class="nvc-fix-height"
        [ngClass]="cartLength ? 'ws-border-bottom-menu' : ''"
        *ngIf="!data.isCartMenuOpened"
      >
        <div
          *ngFor="let collection of slotService.collectionsList; let i = index"
          (mouseenter)="
            data.menuPreviewIndex = i;
            data.showPreview = true;
            cdRef.detectChanges()
          "
          (mouseleave)="data.showPreview = false"
          fxLayout="row"
          class="nvc-drawer-padding ws-cursor-pointer nvc-menu-text nvc-side-gap notranslate"
          fxLayoutAlign="start center"
          (click)="onPreviewClick.emit(i)"
          [ngClass]="
            i === data.menuPreviewIndex ? 'ws-bold nvc-color-hover' : ''
          "
        >
          <span class="sc-ordername">{{ collection.name }}</span>
        </div>
      </div>
    </div>
  </mat-drawer>
  <div
    fxLayout="row"
    fxLayoutGap="2rem"
    fxLayoutAlign="space-evenly center"
    *ngIf="!isMobileDevice"
  >
    <div
      class="nvc-main-menu nvc-circle ws-cursor-pointer sc-home"
      (click)="!isRetailer() ? storesService.redirectToCustomerUrl() : ''"
      *ngIf="!slotService.websitePromolinkCB"
    >
      <mat-icon
        class="nvc-header-image sc-home-icon"
        alt="Home"
        [ngClass]="!isRetailer() ? 'ws-cursor-pointer' : ''"
        [matTooltip]="!isRetailer() ? 'Home' : ''"
        svgIcon="homeIcon"
        [style.color]="'white'"
      ></mat-icon>
      <!-- <div
        *ngIf="cartLength && menuCount && checkCartValidity()"
        class="nvc-menu-cart-count nvc-text-align-center"
      >
        {{ cartLength }}
      </div> -->
    </div>
    <div fxLayout="column">
      <img
        [src]="logoSource"
        (click)="
          slotService.websitePromolinkCB
            ? redirectToLandingPage.emit()
            : this.slotService.onLogoClicked.next(true)
        "
        alt="Buyer Brand Image"
        class="nvc-logo-image ws-cursor-pointer"
        [ngClass]="{
          'sc-margin-left-logo nvc-logo-image-srsm':
            slotService.websitePromolinkCB,
          'nvc-logo-image': !slotService.websitePromolinkCB
        }"
      />
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    class="sc-nav-width"
    fxLayoutGap="20px"
    *ngIf="slotService.websitePromolinkCB && !(isMobileDevice || isTabDevice)"
  >
    <div
      *ngFor="
        let eachBoard of slotService.collectionsList;
        let eachIndex = index
      "
      [ngClass]="{
        'ws-display-none':
          slotService.websitePromolinkCB && eachBoard.includeInWebsiteLanding
      }"
    >
      <h1
        (click)="onPreviewClick.emit(eachIndex)"
        class="nvc-font-header-custom nvc-text-align-center ws-board-name-heading notranslate ws-cursor-pointer"
      >
        {{ eachBoard.name }}
      </h1>
    </div>
  </div>
  <div
    class="nvc-widget"
    *ngIf="data.showProfileIcon"
    [ngClass]="{
      'nvc-widget-height': isMobileDevice,
      'sc-margin-right-icons': fromSummary && isMobileDevice,
      'sc-srsm-icons-padding sc-srsm-icons-height sc-desktop-icons':
        slotService.websitePromolinkCB && !isMobileDevice,
      'sc-desktop-flex-icons': !(
        slotService.websitePromolinkCB && !isMobileDevice
      )
    }"
    fxLayout="row"
    [fxLayoutGap]="
      isMobileDevice
        ? slotService.websitePromolinkCB
          ? '1rem'
          : '8px'
        : '1.5rem'
    "
  >
    <img
      *ngIf="slotService.websitePromolinkCB && !isMobileDevice"
      (click)="goToFooter()"
      class="sc-google-icon-contact ws-cursor-pointer"
      src="assets/icons/contact-us-icon.svg"
      alt=""
    />
    <div
      *ngIf="(!data.showPopup || !isMobileDevice) && !data.showMenu"
      fxLayout="row"
      fxLayoutAlign="center center"
      [fxLayoutGap]="!slotService.websitePromolinkCB ? '0.4rem' : ''"
    >
      <div
        [matMenuTriggerFor]="profileMenu"
        #clickProfileMenuTrigger="matMenuTrigger"
        class="ws-cursor-pointer nvc-position-relative"
        [ngClass]="{
          'sc-border-primary': !loggedIn() && !slotService.websitePromolinkCB,
          'sc-padding': isMobileDevice && !loggedIn(),
          'sc-profile-icon-div':
            !slotService.websitePromolinkCB || isUserUploadedImage()
        }"
        fxLayout="row"
        (click)="checkProfileMenu()"
        fxLayoutAlign="center center"
      >
        <mat-icon
          *ngIf="!loggedIn() && !slotService.websitePromolinkCB"
          svgIcon="userOutlineIcon"
        >
        </mat-icon>
        <img
          *ngIf="
            loggedIn() &&
            !(
              slotService.websitePromolinkCB &&
              (!(
                LiveshopService.currentUser &&
                LiveshopService.currentUser.profileImageURL
              ) ||
                LiveshopService.currentUser.profileImageURL === defaultImage ||
                LiveshopService.currentUser.profileImageURL ===
                  defaultMaleImage ||
                LiveshopService.currentUser.profileImageURL ===
                  defaultFemaleImage ||
                LiveshopService.currentUser.profileImageURL ===
                  defaultOtherImage)
            )
          "
          class="sc-profile-img"
          src="{{
            LiveshopService.currentUser &&
            LiveshopService.currentUser.profileImageURL
              ? imagesService.getImageURL(
                  LiveshopService.currentUser.profileImageURL
                )
              : icons?.businessUserIcon?.defaultImg
          }}"
          alt="userImg"
        />
        <img
          *ngIf="
            slotService.websitePromolinkCB &&
            (!(
              LiveshopService.currentUser &&
              LiveshopService.currentUser.profileImageURL
            ) ||
              LiveshopService.currentUser.profileImageURL === defaultImage ||
              LiveshopService.currentUser.profileImageURL ===
                defaultMaleImage ||
              LiveshopService.currentUser.profileImageURL ===
                defaultFemaleImage ||
              LiveshopService.currentUser.profileImageURL === defaultOtherImage)
          "
          src="assets/icons/account-circle-google-icon.svg"
          class="sc-google-icon-user"
        />
        <div
          class="sc-down-icon-div"
          [ngClass]="
            slotService.websitePromolinkCB
              ? 'sc-down-icon-div-pos-srsm'
              : 'sc-down-icon-div-pos'
          "
          fxLayout="row"
          fxLayoutAlign="center center"
          *ngIf="loggedIn() && !slotService.websitePromolinkCB"
        >
          <mat-icon
            class="sc-down-icon"
            svgIcon="angleDown"
            [style.color]="'white'"
          ></mat-icon>
        </div>
      </div>
      <mat-menu
        #profileMenu="matMenu"
        yPosition="below"
        xPosition="before"
        class="sc-dropdown"
      >
        <div *ngIf="loggedIn()" class="sc-menuItem sc-border-bottom">
          <span class="sc-font-weight-600 notranslate">{{
            LiveshopService.currentUser.displayName
              ? LiveshopService.currentUser?.displayName?.length > 40
                ? LiveshopService.currentUser?.displayName.slice(0, 40) + "..."
                : LiveshopService.currentUser?.displayName
              : LiveshopService.currentUser?.username?.length > 40
              ? LiveshopService.currentUser?.username.slice(0, 40) + "..."
              : LiveshopService.currentUser?.username
          }}</span>
        </div>
        <button
          mat-menu-item
          *ngIf="loggedIn()"
          class="ws-cursor-pointer"
          (click)="promoLinkAuthorizationService.goToMyProfile()"
        >
          <span>My Profile</span>
        </button>
        <button
          mat-menu-item
          *ngIf="loggedIn()"
          class="ws-cursor-pointer"
          (click)="menuActions.emit('myorders')"
        >
          <span>My Orders</span>
        </button>
        <button
          mat-menu-item
          class="ws-cursor-pointer"
          *ngIf="data.showBookings && loggedIn()"
          (click)="menuActions.emit('appointments')"
        >
          <span>My Bookings</span>
        </button>
        <button
          mat-menu-item
          class="ws-cursor-pointer"
          *ngIf="data.showOrders && loggedIn()"
          (click)="menuActions.emit('myaddresses')"
        >
          <span>My Addresses</span>
        </button>
        <button
          mat-menu-item
          class="ws-cursor-pointer"
          (click)="openWishlist.emit()"
          *ngIf="data.showWishList && loggedIn()"
        >
          <span>My Wishlist</span>
        </button>
        <button
          mat-menu-item
          class="ws-cursor-pointer"
          (click)="changePassword.emit()"
          *ngIf="loggedIn()"
        >
          <span>Change Password</span>
        </button>
        <button
          mat-menu-item
          *ngIf="loggedIn()"
          class="ws-cursor-pointer sc-border-top"
          (click)="logOut.emit()"
        >
          <span>Logout</span>
        </button>
      </mat-menu>
    </div>

    <div
      *ngIf="
        !(data.showMenu || (data.showPopup && isMobileDevice)) &&
        !slotService.websitePromolinkCB
      "
      [ngClass]="{
        'nvc-share-tint': !isMobileDevice,
        'nvc-share-mobile-div': isMobileDevice
      }"
      (click)="shareLink.emit()"
      fxLayout="row"
      fxLayoutAlign="center center"
    >
      <mat-icon
        class="nvc-share-icon ws-cursor-pointer"
        svgIcon="shareIcon"
        [style.color]="
          this.isMobileDevice ? this.slotService.primaryThemeColor : 'white'
        "
        alt="share"
        matTooltip="share"
      ></mat-icon>
    </div>
    <div
      class="ws-cursor-pointer nvc-position-relative"
      *ngIf="
        (!data.showPopup || !isMobileDevice) &&
        !data.showMenu &&
        ((!slotService.websitePromolinkCB && isCartEnabled) ||
          (slotService.websitePromolinkCB && data.showWishList))
      "
      fxLayoutAlign="center center"
      (click)="
        slotService.websitePromolinkCB ? openWishlist.emit() : openCart.emit()
      "
      [ngClass]="{
        'sc-padding': isMobileDevice && !slotService.websitePromolinkCB,
        'sc-profile-icon-div sc-border-primary': !slotService.websitePromolinkCB
      }"
    >
      <mat-icon *ngIf="!slotService.websitePromolinkCB" svgIcon="consumerCart">
      </mat-icon>
      <div
        class="ws-cart-count ws-cart-count-pos"
        *ngIf="cartLength && !slotService.websitePromolinkCB"
      >
        {{ cartLength }}
      </div>
      <img
        *ngIf="slotService.websitePromolinkCB"
        class="sc-google-icon-cart"
        src="assets/icons/favorite-google-icon.svg"
        alt=""
      />
    </div>
    <div
      class="ws-cursor-pointer nvc-position-relative"
      *ngIf="
        (!data.showPopup || !isMobileDevice) &&
        !data.showMenu &&
        ((!slotService.websitePromolinkCB && data.showWishList) ||
          (slotService.websitePromolinkCB && isCartEnabled))
      "
      fxLayoutAlign="center center"
      (click)="
        !slotService.websitePromolinkCB ? openWishlist.emit() : openCart.emit()
      "
      [ngClass]="{
        'sc-padding': isMobileDevice && !slotService.websitePromolinkCB,
        'sc-profile-icon-div sc-border-primary': !slotService.websitePromolinkCB
      }"
    >
      <mat-icon
        *ngIf="!slotService.websitePromolinkCB"
        class="fa fa-heart-o sc-wishlist"
      ></mat-icon>
      <img
        *ngIf="slotService.websitePromolinkCB"
        class="sc-google-icon-cart"
        src="assets/icons/shopping-cart-google-icon.svg"
        alt=""
      />
      <div
        class="ws-cart-count"
        [ngClass]="{
          'ws-cart-count-srsm': !isMobileDevice,
          'ws-cart-count-srsm-mobile': isMobileDevice
        }"
        *ngIf="cartLength && slotService.websitePromolinkCB"
      >
        {{ cartLength }}
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="
    (!slotService.isEmbedded &&
      slotService.is3DBoard &&
      slotService.isHeaderAndFooter &&
      !data.showMenu &&
      (!(isMobileDevice || isTabDevice) ||
        ((isMobileDevice || isTabDevice) && !data.showPopup))) ||
    slotService.isSTLPromolink ||
    slotService.is3DBoard ||
    data?.ARDialog
  "
  class="nvc-3d-header"
  [ngClass]="{
    'padding-left-1rem': slotService.is3DBoard && !isMobileDevice,
    'nvc-3d-header-new':
      !(isMobileDevice || isTabDevice) && slotService.is3DBoard
  }"
>
  <mat-drawer
    #collectionsListDrawer
    mode="over"
    class="nvc-mat-drawer"
    [ngClass]="
      isMobileDevice || isTabDevice
        ? 'nvc-mat-drawer-mobile nvc-position-absolute'
        : ''
    "
    fxLayout="row"
    *ngIf="slotService.is3DBoard && (isMobileDevice || isTabDevice)"
  >
    <div
      class="grid-view-main-container"
      *ngIf="data.gridView"
      [ngClass]="{
        'nvc-add-scroll': slotService.collectionsList?.length > 12,
        'center-align-grid': !(slotService.collectionsList?.length > 12)
      }"
    >
      <div id="gallery">
        <div
          fxLayout="row"
          class="ws-cursor-pointer nvc-menu-text nvc-margin-menu nvc-position-absolute nvc-menu-height"
          fxLayoutAlign="start center"
        >
          <mat-icon
            (click)="collectionsListDrawer.close(); data.showMenu = false"
            matTooltip="close"
            class="ws-cursor-pointer"
            style="padding-right: 20px"
            >close</mat-icon
          >
          <div class="nvc-menu nvc-menu-text">Menu</div>
          <img
            (click)="data.gridView = false"
            matTooltip="Grid View"
            class="nvc-video-cam ws-cursor-pointer"
            src="assets/icons/view_agenda_black.svg"
            alt=""
          />
        </div>

        <div
          (click)="onPreviewClick.emit(i)"
          *ngFor="let collection of slotService.collectionsList; let i = index"
          class="video-container-grid"
        >
          <div style="width: 100%; height: 100%" class="nvc-position-relative">
            <div class="nvc-grid-name nvc-position-absolute">
              {{ collection.name }}
            </div>
            <img
              *ngIf="data.previewImages[slotService.collectionsList[i]._id]"
              src="{{ data.previewImages[slotService.collectionsList[i]._id] }}"
              style="width: 100%; height: 100%; object-fit: contain"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="!data.gridView"
      class="nvc-new-sidebar nvc-height-hundred nvc-position-relative"
      fxLayout="column"
      (mouseleave)="closeMenuAction()"
    >
      <div
        class="nvc-position-relative nvc-side-gap nvc-width-hundred"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <img
          [src]="
            data.buyerImage
              ? imagesService.getImageURL(data.buyerImage)
              : 'assets/icons/Shopconnect_logo_new.png'
          "
          alt="Buyer Brand Image"
          class="nvc-buyer-image"
          [ngClass]="
            (isMobileDevice || isTabDevice) && slotService.is3DBoard
              ? 'nvc-buyer-image-3d'
              : ''
          "
        />
        <mat-icon
          *ngIf="!(isMobileDevice || isTabDevice)"
          (click)="closeMenuAction()"
          matTooltip="Close"
          class="ws-cursor-pointer nvc-close-icon"
          >close</mat-icon
        >
      </div>
      <div
        *ngIf="!data.isCartMenuOpened"
        fxLayout="row"
        fxLayoutAlign="start center"
        class="nvc-margin-menu-header nvc-side-gap"
      >
        <div fxLayout="row" FxLayoutAlign="space-evenly">
          <div
            class="nvc-collection-index nvc-menu-hover"
            fxLayout="row"
            FxLayoutAlign="center center"
            [ngClass]="
              data.collectionIndex > 9
                ? 'nvc-font-smaller nvc-padding-small'
                : 'nvc-font-16'
            "
          >
            <span>{{ data.collectionIndex }}</span>
            <span
              [ngClass]="
                slotService.collectionsList?.length > 9
                  ? 'nvc-count-denom'
                  : 'nvc-font-small'
              "
              >/{{ slotService.collectionsList.length }}</span
            >
          </div>

          <div
            class="nvc-menu-text ws-bold nvc-padding-top sc-menu sc-ordername"
            [ngClass]="
              isMobileDevice || isTabDevice ? 'sc-menu-text-width-mobile' : ''
            "
            [matTooltip]="data.orderName"
          >
            {{ data.orderName }}
          </div>
        </div>
      </div>
      <div
        *ngIf="data.isCartMenuOpened"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="0.5em"
        class="nvc-margin-menu-header nvc-side-gap-cart"
      >
        <mat-icon
          class="ws-cursor-pointer"
          matTooltip="Back to Menu"
          (click)="closeCartMenu()"
          >keyboard_arrow_down</mat-icon
        >

        <ng-container *ngIf="isMobileDevice || isTabDevice">
          <div class="nvc-cart-menu-mobile">
            <mat-icon
              class="ws-cursor-pointer"
              (click)="data.isCartMenuOpened = !data.isCartMenuOpened"
              alt="Show Cart"
              svgIcon="cartIcon"
              [style.color]="slotService.primaryThemeColor"
            ></mat-icon>
            <div
              class="nvc-cart-number-menu-mobile nvc-text-align-center"
              (click)="cartOpenLoginCheck() && loggedIn()"
            >
              {{ data.cartItems?.length }}
            </div>
          </div>
          <div class="nvc-cart-text-mobile">
            <span>Cart Items</span>
          </div>
          <button
            class="ws-checkout-button-menu ws-checkout-button-mobile ws-cursor-pointer ws-border-none ws-outline-none"
            [ngClass]="
              data.cartItems?.length
                ? 'ws-checkout-button-activate'
                : 'ws-checkout-button-deactivate'
            "
            (click)="checkout.emit()"
            [disabled]="!data.cartItems?.length"
          >
            Check out
          </button>
        </ng-container>
        <ng-container *ngIf="!(isMobileDevice || isTabDevice)">
          <mat-icon
            class="ws-cursor-pointer"
            alt="Show Cart"
            svgIcon="cartIcon"
            [style.color]="slotService.primaryThemeColor"
          ></mat-icon>
          <span class="nvc-cart-text">Cart Items</span>
          <div class="nvc-cart-number-menu-top nvc-text-align-center">
            {{ data.cartItems?.length }}
          </div>
        </ng-container>
      </div>
      <div
        class="nvc-fix-height"
        [ngClass]="
          cartLength || slotService.is3DBoard ? 'ws-border-bottom-menu' : ''
        "
        *ngIf="!data.isCartMenuOpened"
      >
        <div
          *ngFor="let collection of slotService.collectionsList; let i = index"
          (mouseenter)="
            data.menuPreviewIndex = i;
            data.showPreview = true;
            cdRef.detectChanges()
          "
          (mouseleave)="data.showPreview = false"
          fxLayout="row"
          class="nvc-drawer-padding ws-cursor-pointer nvc-menu-text nvc-side-gap"
          fxLayoutAlign="start center"
          (click)="onPreviewClick.emit(i)"
          [ngClass]="
            i === data.menuPreviewIndex ? 'ws-bold nvc-color-hover' : ''
          "
        >
          <span class="sc-ordername">{{ collection.name }}</span>
        </div>
      </div>
      <div
        class="nvc-fix-height"
        [ngClass]="
          cartLength || slotService.is3DBoard ? 'ws-border-bottom-menu' : ''
        "
        *ngIf="data.isCartMenuOpened"
        fxLayout="column"
        fxLayoutGap="1em"
      >
        <div
          *ngFor="let item of data.cartItems; let i = index"
          class="ws-cart-list"
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <img
            [src]="
              imagesService.getImageURL(item.gallery.images[0].originalImageURL)
            "
            class="ws-item-image"
            alt=""
          />
          <div
            class="ws-cart-product-details"
            fxLayout="column"
            fxLayoutGap="1em"
          >
            <span class="ws-cart-main">{{
              item && item.brandVarietyName
                ? item.brandVarietyName
                : item && item.productName
                ? item.productName
                : item.instantProduct?.name
            }}</span>
            <span class="ws-cart-price">{{
              item && item.size ? item.size : "STANDARD SIZE"
            }}</span>

            <span class="ws-cart-price" *ngIf="data.showPrice">{{
              item.instantProduct?.price
                ? this.slotService.getFormattedCurrency(
                    item.instantProduct.price
                  )
                : this.LiveshopService.getProductPrice(item)
                ? this.slotService.getFormattedCurrency(
                    this.LiveshopService.getProductPrice(item)
                  )
                : ""
            }}</span>
          </div>
          <div class="ws-close-div">
            <img
              (click)="removeCartProduct.emit(item)"
              class="ws-close-icon-cart ws-cursor-pointer"
              src="assets/icons/close-collection.svg"
              alt=""
            />
          </div>
        </div>
      </div>
      <div
        *ngIf="!data.isCartMenuOpened"
        class="ws-margin-cart"
        [ngClass]="
          !(isMobileDevice || isTabDevice) ? 'nvc-cart-left-margin' : ''
        "
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <div
          *ngIf="
            (isMobileDevice || isTabDevice) &&
            data.menuCartProducts &&
            data.menuCartProducts.length &&
            checkChatValidity('cart') &&
            slotService.is3DBoard
          "
          class="nvc-cart-menu-mobile"
        >
          <mat-icon
            class="ws-cursor-pointer ws-up-icon-left-margin-mobile"
            matTooltip="Cart"
            (click)="cartOpenLoginCheck()"
            >keyboard_arrow_up</mat-icon
          >
          <mat-icon
            class="ws-cursor-pointer nvc-cart-left-margin"
            (click)="cartOpenLoginCheck()"
            alt="Show Cart"
            svgIcon="cartIcon"
            [style.color]="slotService.primaryThemeColor"
          ></mat-icon>
          <div
            class="nvc-cart-number-menu-mobile nvc-text-align-center"
            (click)="cartOpenLoginCheck() && loggedIn()"
          >
            {{ data.cartItems?.length }}
          </div>
        </div>
        <div
          *ngIf="
            (data.showMenu || data.showPopup) && (isMobileDevice || isTabDevice)
          "
          class="nvc-box-shadow nvc-circle nvc-mobile-close"
          [ngClass]="!slotService.is3DBoard ? 'nvc-margin-bottom-mobile' : ''"
          (click)="closeMenuAction()"
        >
          <mat-icon class="ws-cursor-pointer">close</mat-icon>
        </div>
        <ng-container
          *ngIf="
            !(isMobileDevice || isTabDevice) &&
            !data.isBusinessUser &&
            checkChatValidity('cart') &&
            !fromCart
          "
        >
          <mat-icon
            class="nvc-cart-menu ws-cursor-pointer"
            alt="Show Cart"
            svgIcon="cartIcon"
            (click)="cartOpenLoginCheck()"
            [style.color]="slotService.primaryThemeColor"
          ></mat-icon>
          <span
            class="nvc-cart-text-bottom ws-cursor-pointer"
            matTooltip="View Cart Items"
            (click)="cartOpenLoginCheck() && loggedIn()"
            >Cart
          </span>
          <div class="nvc-cart-number-menu nvc-text-align-center">
            {{ data.cartItems?.length }}
          </div>
        </ng-container>

        <div
          *ngIf="!data.isBusinessUser"
          fxLayout="row"
          fxLayoutAlign="flex-end center"
          class="ws-margin-powered nvc-powered-by nvc-position-fixed"
        >
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="nvc-powered-font-weight ws-cursor-pointer"
            (click)="slotService.redirectPoweredBy()"
          >
            <p>Powered By&nbsp;</p>
            <img
              class="nvc-powered-by-menu"
              alt="shopconnect"
              src="assets/icons/powered-Color-new.png"
            />
          </div>
        </div>
      </div>
      <div
        *ngIf="data.isCartMenuOpened"
        class="ws-margin-cart"
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        <div
          *ngIf="
            (data.showMenu || data.showPopup) && (isMobileDevice || isTabDevice)
          "
          class="nvc-box-shadow nvc-circle nvc-mobile-close"
          (click)="closeMenuAction()"
        >
          <mat-icon class="ws-cursor-pointer">close</mat-icon>
        </div>
        <button
          *ngIf="!(isMobileDevice || isTabDevice) && !data.isBusinessUser"
          class="ws-checkout-button-menu ws-cursor-pointer ws-border-none ws-outline-none"
          [ngClass]="
            data.cartItems?.length
              ? 'ws-checkout-button-activate'
              : 'ws-checkout-button-deactivate'
          "
          (click)="checkout.emit()"
          [disabled]="!data.cartItems?.length"
        >
          Check out
        </button>
      </div>
    </div>
  </mat-drawer>
  <div
    fxFlex="100"
    fxLayoutAlign="space-between center"
    fxLayout="row"
    class="nvc-position-relative"
  >
    <div
      class="nvc-main-menu nvc-circle ws-cursor-pointer"
      (click)="clickMenu()"
      *ngIf="
        !slotService.is3DBoard &&
        !slotService.isSTLPromolink &&
        !(isMobileDevice || isTabDevice) &&
        !data.isRoomPlan &&
        boardType !== 'CB' &&
        boardType !== '3D' &&
        !ARDialog
      "
    >
      <mat-icon
        class="nvc-header-image ws-cursor-pointer"
        alt="Collections List"
        matTooltip="Collections List"
        svgIcon="menuIcon"
        [style.color]="'white'"
      ></mat-icon>
      <div
        *ngIf="cartLength && menuCount && checkCartValidity()"
        class="nvc-menu-cart-count nvc-text-align-center"
      >
        {{ cartLength }}
      </div>
    </div>
    <div
      fxLayoutAlign="start center"
      [ngClass]="{
        'sc-left-header-logo': !(isMobileDevice || isTabDevice),
        'sc-left-zero': !(isMobileDevice || isTabDevice)
      }"
    >
      <mat-icon
        *ngIf="
          (isMobileDevice || isTabDevice) &&
          slotService.is3DBoard &&
          !data?.ARDialog
        "
        (click)="clickMenu()"
        class="ws-cursor-pointer"
        alt="Collections List 1"
        svgIcon="menuIcon"
        [style.color]="'black'"
      ></mat-icon>
      <img
        [src]="logoSource"
        [ngClass]="{
          'nvc-3d-header-logo-new':
            slotService.is3DBoard && !(isMobileDevice || isTabDevice),
          'nvc-3d-header-logo-new-mobile':
            slotService.is3DBoard && (isMobileDevice || isTabDevice),
          'nvc-logo-margin-roomplan':
            !(isMobileDevice || isTabDevice) && data.isRoomPlan,
          'ws-cursor-pointer': !ARDialog
        }"
        (click)="this.slotService.onLogoClicked.next(true)"
        alt="Buyer Brand Image"
        class="nvc-3d-header-logo"
      />
    </div>
    <div
      *ngIf="!(isMobileDevice || isTabDevice) && !slotService.is3DBoard"
      fxFlex="100"
      fxLayoutAlign="center center"
      class="nvc-3d-company-name notranslate"
    >
      {{ data.orderName }}
    </div>
    <div
      *ngIf="
        slotService.is3DBoard &&
        !(isMobileDevice || isTabDevice) &&
        !isTabDevice
      "
      fxLayoutAlign="center center"
      fxLayoutGap="60px"
      class="nvc-3d-board-name notranslate"
      [ngClass]="slotService.isSTLPromolink ? 'sc-margin-left-zero' : ''"
    >
      <span
        *ngFor="let collection of slotService.collectionsList; let i = index"
        class="nvs-adjust-header nvc-uppercase"
        (click)="changeBoard.emit(i)"
        [ngClass]="
          (data.collectionIndex || 1) - 1 === i
            ? 'ws-primary-color'
            : 'ws-cursor-pointer'
        "
      >
        {{ collection.name }}
      </span>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="end center"
      [fxLayoutGap]="
        isMobileDevice || isTabDevice
          ? slotService.is3DBoard
            ? '0rem'
            : '1rem'
          : slotService.is3DBoard
          ? '32px'
          : '1rem'
      "
      class="sc-right-zero"
      [ngClass]="{
        'sc-3d-profile-icons':
          slotService.is3DBoard && !(isMobileDevice || isTabDevice)
      }"
    >
      <app-locale
        fxLayout
        fxLayoutAlign="center center"
        *ngIf="isEuropean"
        class="ws-margin-right-none"
      ></app-locale>
      <div
        *ngIf="!data.isBusinessUser && !hideProfile"
        fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutGap="0.4rem"
        [ngClass]="{
          'sc-profile-icon-div-3d-mobile-new-container':
            slotService.is3DBoard &&
            (isMobileDevice || isTabDevice) &&
            loggedIn()
        }"
      >
        <div
          [matMenuTriggerFor]="profileMenu"
          #clickProfileMenuTrigger="matMenuTrigger"
          class="ws-cursor-pointer sc-profile-icon-div-3d nvc-position-relative"
          [ngClass]="{
            'sc-border-primary': !loggedIn() && !slotService.is3DBoard,
            'sc-padding': isMobileDevice && !loggedIn(),
            'sc-profile-icon-div-3d-tab-new':
              slotService.is3DBoard && isTabDevice && loggedIn()
          }"
          fxLayout="row"
          (click)="checkProfileMenu()"
          fxLayoutAlign="center center"
        >
          <mat-icon *ngIf="!loggedIn()" svgIcon="userOutlineIcon"> </mat-icon>
          <img
            *ngIf="loggedIn()"
            class="sc-profile-img"
            src="{{
              LiveshopService.currentUser &&
              LiveshopService.currentUser.profileImageURL
                ? imagesService.getImageURL(
                    LiveshopService.currentUser.profileImageURL
                  )
                : icons?.businessUserIcon?.defaultImg
            }}"
            alt="userImg"
          />
          <div
            class="sc-down-icon-div sc-down-icon-div-pos"
            fxLayout="row"
            fxLayoutAlign="center center"
            *ngIf="loggedIn()"
          >
            <mat-icon
              class="sc-down-icon"
              svgIcon="angleDown"
              [style.color]="'white'"
            ></mat-icon>
          </div>
        </div>
        <mat-menu
          #profileMenu="matMenu"
          yPosition="below"
          xPosition="before"
          class="sc-dropdown"
        >
          <div
            *ngIf="!loggedIn()"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="1rem"
            class="sc-background-primary sc-menuItem sc-login-item ws-cursor-pointer"
            (click)="loginDialogOpen.emit()"
          >
            <span>Login</span>
            <mat-icon class="fa fa-arrow-right" color="white"> </mat-icon>
          </div>
          <div *ngIf="loggedIn()" class="sc-menuItem sc-border-bottom">
            <span class="sc-font-weight-600">{{
              LiveshopService.currentUser.displayName
                ? LiveshopService.currentUser?.displayName?.length > 40
                  ? LiveshopService.currentUser?.displayName.slice(0, 40) +
                    "..."
                  : LiveshopService.currentUser?.displayName
                : LiveshopService.currentUser?.username?.length > 40
                ? LiveshopService.currentUser?.username.slice(0, 40) + "..."
                : LiveshopService.currentUser?.username
            }}</span>
          </div>
          <div></div>
          <button
            mat-menu-item
            *ngIf="loggedIn()"
            class="ws-cursor-pointer"
            (click)="promoLinkAuthorizationService.goToMyProfile()"
          >
            <span>My Profile</span>
          </button>
          <button
            mat-menu-item
            class="ws-cursor-pointer"
            *ngIf="loggedIn()"
            (click)="menuActions.emit('myorders')"
          >
            <span>My Orders</span>
          </button>
          <button
            mat-menu-item
            class="ws-cursor-pointer"
            *ngIf="showBookings && loggedIn()"
            (click)="menuActions.emit('appointments')"
          >
            <span>My Bookings</span>
          </button>
          <button
            mat-menu-item
            class="ws-cursor-pointer"
            *ngIf="showOrders && loggedIn()"
            (click)="menuActions.emit('myaddresses')"
          >
            <span>My Addresses</span>
          </button>
          <button
            mat-menu-item
            class="ws-cursor-pointer"
            (click)="openWishlist.emit()"
            *ngIf="showWishList && loggedIn()"
          >
            <span>My Wishlist</span>
          </button>
          <button
            mat-menu-item
            class="ws-cursor-pointer"
            (click)="changePassword.emit()"
            *ngIf="loggedIn()"
          >
            <span>Change Password</span>
          </button>
          <button
            mat-menu-item
            *ngIf="loggedIn()"
            class="ws-cursor-pointer sc-border-top"
            (click)="logOut.emit()"
          >
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
      <div
        class="sc-profile-icon-div-3d ws-cursor-pointer"
        fxLayoutAlign="center center"
        (click)="openWishlist.emit()"
        [ngClass]="{
          'sc-padding': isMobileDevice,
          'sc-margin-right-6px':
            (isMobileDevice || isTabDevice) && slotService.is3DBoard,
          'sc-border-primary': !slotService.is3DBoard
        }"
        *ngIf="!data.isBusinessUser && showWishList"
      >
        <mat-icon class="fa fa-heart-o sc-wishlist"></mat-icon>
      </div>

      <div
        class="sc-profile-icon-div-3d ws-cursor-pointer nvc-position-relative"
        fxLayoutAlign="center center"
        (click)="openCart.emit()"
        [ngClass]="{
          'sc-padding': isMobileDevice,
          'sc-border-primary': !slotService.is3DBoard,
          'nvc-3d-cart-icon': slotService.is3DBoard && !isMobileDevice,
          'nvc-3d-cart-icon-mobile': slotService.is3DBoard && isMobileDevice
        }"
        *ngIf="!data.isBusinessUser && isCartEnabled"
      >
        <mat-icon
          [svgIcon]="slotService.is3DBoard ? 'cartIcon' : 'consumerCart'"
        >
        </mat-icon>
        <div
          class="ws-cart-count"
          [ngClass]="
            slotService.is3DBoard
              ? isMobileDevice
                ? 'nvc-cart-count-align-mobile'
                : 'nvc-cart-count-align'
              : 'nvc-cart-count-stl'
          "
          *ngIf="cartLength"
        >
          {{ cartLength }}
        </div>
      </div>
    </div>
  </div>
</div>
